import React from 'react';
import VisibilitySensor from 'react-visibility-sensor';

import TimeFormat from '@scripts/utilities/time-format.js';

import Analytics from '../Analytics/index.jsx';
import ArticleExcerpt from '../ArticleExcerpt/index.jsx';
import BackgroundImage from '../BackgroundImage/index.jsx';
import LockButton from '../LockButton/index.jsx';
import Button from 'react-bootstrap/Button';


class NewsletterBlogButton extends React.Component {
  render() {
    var title = 'Read';

    if (this.props.type == 'video') {
      title = 'Watch';
    }

    return (
      <LockButton
        href={this.props.permalink}
        onClick={this.props.onClick}
      >
        {title}
      </LockButton>
    );
  }
}


class NewsletterBlog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showContent: false
    };

    this.viewPage = this.viewPage.bind(this);
    this.sendAnalytics = this.sendAnalytics.bind(this);
  }

  viewPage(e) {
    e.preventDefault();
    var trigger = new CustomEvent("cs:article", {
      detail: {
        id: this.props.article.id.toString(),
        slug: this.props.article.slug,
        analytics: this.props.article.analytics
      }
    });
    window.dispatchEvent(trigger);
  }

  sendAnalytics(isVisible) {
    if (isVisible) {
      CSAnalytics("Content Summary Seen", this.props.article.analytics)
    }
  }

  render() {
    var article = this.props.article;

    var content = (
      <Analytics.OutboundLinkTracker eventProperties={article.analytics}>
        <ArticleExcerpt excerpt={article.excerpt} />
      </Analytics.OutboundLinkTracker>
    );


    return (
      <VisibilitySensor
        onChange={this.sendAnalytics}
        partialVisibility={true}
        offset={{bottom:300, top:300}}
      >
        <div className="col-12 no-gutters cs-research-report-article cs-research-report-article--feed">
          <div className="row overflow-hidden flex-fill flex-md-row position-relative">
            <div className={`col-4 col-md-2 img-play-icon-${article.type}`}>
              <a href={article.permalink} className="icon" onClick={this.viewPage} title={`${article.type==='video'?'Watch':'Read'}`}>
                <BackgroundImage image={article.image} variant="square" overlayimage="video" />
              </a>
            </div>

            <div className="col-8 col-md-10 col-lg-10">
              <h2 className="title" dangerouslySetInnerHTML={{ __html: article.title }} />
              <div className="cs-article-metadata__newsletter-type mb-2 mt-1">{article.newsletter_category ? <span className="badge badge-dark">{article.newsletter_category}</span> : ""}</div>
              <h3 className="publish-date">{TimeFormat(article.timestamp)}</h3>
              <div className="d-none d-md-block flex-fill">
                {content}
              </div>

              <div className="mt-4 d-none d-md-block">
                <NewsletterBlogButton
                  {...article}
                  onClick={this.viewPage}
                />
              </div>          
            </div>

            
            <div className="col-12 p-2">
              <div className="flex-fill d-md-none">
                {content}
              </div>
            </div>

            <div className="mt-1 ml-2 d-md-none">
                <NewsletterBlogButton
                  {...article}
                  onClick={this.viewPage}
                />
              </div>
          </div>
        </div>
      </VisibilitySensor>
    );
  }
}


export default NewsletterBlog;

